// extracted by mini-css-extract-plugin
module.exports = {"unordered-list":"RemoveAppFromMetasiteConfirmation__unordered-list___f17E5"};